// extracted by mini-css-extract-plugin
export default {"cautionBox":"k9-z"};